import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { SignUpService } from '../sign-ups/sign-ups.service';
import { CommentsService } from './comments.service';
import { Comment } from './Comment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CommonService } from '../common/common.services';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
  public loading = false;
  @ViewChild('paginator') paginator: MatPaginator;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  displayedColumns: string[] = [
    'Id',
    'SignupId',
    'Date',
    'Comment',
    'PersonId',
  ];

  dataSource: MatTableDataSource<Comment>;

  constructor(private breakpointObserver: BreakpointObserver,
    private signUpService: SignUpService,
    private router: ActivatedRoute,
    private commonService: CommonService,
    private commentsService: CommentsService
  ) { }

  applicantId: string;
  fullName: string;
  commentList: Comment[];
  date: string;
  comment: string;

  ngOnInit(): void {
    this.loading = true;
    this.applicantId = this.router.snapshot.queryParamMap.get('applicantId');
    this.signUpService.getSignUpApplicantById(this.applicantId).subscribe(
      (applicant) => {
        this.fullName = applicant.first_name + ' ' + applicant.last_name
        this.fetchComments(this.applicantId);
      }
    )
    setTimeout(()=>{
      this.loading = false;
    }, 3000)
  }

  addComments() {
    let description = new Comment()
    description.signupId = this.applicantId;
    description.date = this.date;
    description.comment = this.comment;
    description.personId = localStorage.getItem('administratorId');
    this.commentsService.addCommentsForSignUpApplicant(description).subscribe(
      (results) => {
        this.fetchComments(this.applicantId);
      }
    );
  }

  fetchComments(applicantId: string) {
    this.commentsService.getCommentsForSignUpApplicant(this.applicantId).subscribe(
      (comments) => {
        this.commentList = comments;
        this.dataSource = new MatTableDataSource(this.commentList);
        this.dataSource.paginator = this.paginator;
      }
    )
  }

  downloadCommentsExcelFile() {
    this.commonService.getCurrentYear().subscribe((response) => {
      let currentYear = response.response;
      this.commentsService
        .getApplicantsCommentsExcelFile(this.applicantId)
        .subscribe((blob) => {
          saveAs(blob, 'Comments.xlsx');
        });
    });
  }

}
